import { Button, Offcanvas } from "react-bootstrap";
import React, { useState } from "react";
import BannerSlider from "./Banner";

export const Hero = () => {
  const [show, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const scrollToSection = (sectionId) => {
    const element = document.getElementById(sectionId);
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
      handleClose(); // Close mobile menu if open
    }
  };

  return (
    <div
      style={{ display: "flex", flexDirection: "column", minHeight: "70vh"}}
    >

      {/* <div className="top-header">
        <svg
          width="14"
          height="13"
          viewBox="0 0 14 13"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            d="M7.19607 1.56873L6.19227 4.62055C6.1409 4.77674 6.05356 4.91869 5.9373 5.03495C5.82103 5.15122 5.67909 5.23855 5.52289 5.28993L2.47107 6.29373L5.52289 7.29753C5.67909 7.3489 5.82103 7.43623 5.9373 7.5525C6.05356 7.66876 6.1409 7.81071 6.19227 7.9669L7.19607 11.0187L8.19987 7.9669C8.25124 7.81071 8.33858 7.66876 8.45484 7.5525C8.57111 7.43623 8.71305 7.3489 8.86924 7.29753L11.9211 6.29373L8.86924 5.28993C8.71305 5.23855 8.57111 5.15122 8.45484 5.03495C8.33858 4.91869 8.25124 4.77674 8.19987 4.62055L7.19607 1.56873Z"
            stroke="black"
            strokeWidth="0.7875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M3.52112 1.56873V3.66873"
            stroke="black"
            strokeWidth="0.7875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M10.8711 8.91882V11.0188"
            stroke="black"
            strokeWidth="0.7875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M2.47107 2.61877H4.57107"
            stroke="black"
            strokeWidth="0.7875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
          <path
            d="M9.82104 9.96875H11.921"
            stroke="black"
            strokeWidth="0.7875"
            strokeLinecap="round"
            strokeLinejoin="round"
          />
        </svg>

        <p className="mb-0">Join our Community on January 29th</p>
        <a href="#">Read More </a>
      </div> */}
      <div
        style={{ display: "flex", flexDirection: "column", minHeight: "70vh" }}
      >
        {/* Video Background */}
        <div className="video-container">
          <video autoPlay loop muted playsInline className="background-video">
            <source src="/images/waves2.mp4" type="video/mp4" />
            Your browser does not support the video tag.
          </video>
          {/* Opacity Overlay */}
          <div  className="video-overlay"></div>
        </div>

        {/* Desktop Navigation */}
        <div className="d-none d-lg-block">
          <div className="header">
            <div>
              {/* <ul>
                <li> */}
              {/* <button
                    onClick={() => scrollToSection("about")}
                    className="nav-link"
                  >
                    About
                  </button> */}
              {/* </li>
                <li> */}
              {/* <button
                    onClick={() => scrollToSection("features")}
                    className="nav-link"
                  >
                    Features
                  </button> */}
              {/* </li>
              </ul> */}
            </div>

            <div
              className="logo-container"
              style={{
                position: "absolute",
                left: "50%",
                transform: "translateX(-50%)",
              }}
            >
              <img className="logo-image" src="/images/tabolutlogoWHITE.png" alt="logo" />

            </div>

            <div className="d-flex align-items-center gap-3">
              <a
                href="https://www.instagram.com/stabolut"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="#fff"
                >
                  <path
                    d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                  />
                </svg>
              </a>
              <a
                href="https://t.me/stabolutnews"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="white"
                >
                  <path
                    d="M21.643 2.937a1.5 1.5 0 0 0-1.566-.206L2.779 10.144a1.5 1.5 0 0 0 .162 2.796l4.413 1.482 2.235 4.674a1.5 1.5 0 0 0 2.502.289l2.22-2.672 3.978 3.089a1.5 1.5 0 0 0 2.365-1.115l1.98-14.79a1.5 1.5 0 0 0-.991-1.86zM8.57 12.11l7.82-5.224c.238-.158.467.168.268.365l-6.24 6.162a1.503 1.503 0 0 0-.385.666l-.62 2.383c-.06.23-.38.249-.475.027l-1.14-2.633a1.5 1.5 0 0 1 .772-1.746z"
                  />
                </svg>
              </a>

              <a
                href="https://x.com/stabolut"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="white"
                >
                  <path
                    d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                  />
                </svg>
              </a>

              <a
                href="https://warpcast.com/stabolut"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="white"
                >
                  <path
                    d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 2c3.313 0 6 2.687 6 6s-2.687 6-6 6-6-2.687-6-6 2.687-6 6-6zm0 2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
                  />
                </svg>
              </a>

              <a
                href="https://www.linkedin.com/company/stabolut/"
                target="_blank"
                rel="noopener noreferrer"
                className="store-badge"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  viewBox="0 0 24 24"
                  width="20"
                  height="20"
                  fill="white"
                >
                  <path
                    d="M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM8 19H5V8h3v11zM6.5 6.732c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zM20 19h-3v-5.604c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.396-2.586 7-2.777 7 2.476V19z"
                  />
                </svg>
              </a>
            </div>
          </div>
        </div>

        {/* Mobile Navigation */}
        <div className="d-block d-lg-none">
          <div className="header">
            <div className="">
               <img className="logo-image" src="/images/tabolutlogoWHITE.png" alt="logo" />
            </div>

            <svg
              width="20"
              onClick={handleShow}
              height="20"
              viewBox="0 0 24 24"
              fill="none"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                d="M3 18V16H21V18H3ZM3 13V11H21V13H3ZM3 8V6H21V8H3Z"
                fill="#FEF7FF"
              />
            </svg>

            <Offcanvas show={show} onHide={handleClose}>
              <Offcanvas.Header closeButton>
                <Offcanvas.Title>
                  <div className="">
                    <img src="/images/logo.png" alt="logo" />
                  </div>
                </Offcanvas.Title>
              </Offcanvas.Header>
              <Offcanvas.Body>
                {/* <div className="nav-bar">
                  <ul className="mobile-nav-links">
                    <li>
                      <button
                        onClick={() => scrollToSection("about")}
                        className="nav-link"
                      >
                        About
                      </button>
                    </li>
                    <li>
                      <button
                        onClick={() => scrollToSection("features")}
                        className="nav-link"
                      >
                        Features
                      </button>
                    </li>
                    <li>

                    </li>
                  </ul>
                </div> */}
                <div className="d-flex align-items-center gap-3" style={{ flexDirection: "row", justifyContent: "center" }}>
                  <a
                    href="https://www.instagram.com/stabolut"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-badge"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="#000"
                    >
                      <path
                        d="M12 2.163c3.204 0 3.584.012 4.85.07 3.252.148 4.771 1.691 4.919 4.919.058 1.265.069 1.645.069 4.849 0 3.205-.012 3.584-.069 4.849-.149 3.225-1.664 4.771-4.919 4.919-1.266.058-1.644.07-4.85.07-3.204 0-3.584-.012-4.849-.07-3.26-.149-4.771-1.699-4.919-4.92-.058-1.265-.07-1.644-.07-4.849 0-3.204.013-3.583.07-4.849.149-3.227 1.664-4.771 4.919-4.919 1.266-.057 1.645-.069 4.849-.069zm0-2.163c-3.259 0-3.667.014-4.947.072-4.358.2-6.78 2.618-6.98 6.98-.059 1.281-.073 1.689-.073 4.948 0 3.259.014 3.668.072 4.948.2 4.358 2.618 6.78 6.98 6.98 1.281.058 1.689.072 4.948.072 3.259 0 3.668-.014 4.948-.072 4.354-.2 6.782-2.618 6.979-6.98.059-1.28.073-1.689.073-4.948 0-3.259-.014-3.667-.072-4.947-.196-4.354-2.617-6.78-6.979-6.98-1.281-.059-1.69-.073-4.949-.073zm0 5.838c-3.403 0-6.162 2.759-6.162 6.162s2.759 6.163 6.162 6.163 6.162-2.759 6.162-6.163c0-3.403-2.759-6.162-6.162-6.162zm0 10.162c-2.209 0-4-1.79-4-4 0-2.209 1.791-4 4-4s4 1.791 4 4c0 2.21-1.791 4-4 4zm6.406-11.845c-.796 0-1.441.645-1.441 1.44s.645 1.44 1.441 1.44c.795 0 1.439-.645 1.439-1.44s-.644-1.44-1.439-1.44z"
                      />
                    </svg>
                  </a>
                  <a
                    href="https://t.me/stabolutnews"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-badge"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="#000"
                    >
                      <path
                        d="M21.643 2.937a1.5 1.5 0 0 0-1.566-.206L2.779 10.144a1.5 1.5 0 0 0 .162 2.796l4.413 1.482 2.235 4.674a1.5 1.5 0 0 0 2.502.289l2.22-2.672 3.978 3.089a1.5 1.5 0 0 0 2.365-1.115l1.98-14.79a1.5 1.5 0 0 0-.991-1.86zM8.57 12.11l7.82-5.224c.238-.158.467.168.268.365l-6.24 6.162a1.503 1.503 0 0 0-.385.666l-.62 2.383c-.06.23-.38.249-.475.027l-1.14-2.633a1.5 1.5 0 0 1 .772-1.746z"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://x.com/stabolut"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-badge"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="#000"
                    >
                      <path
                        d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://warpcast.com/stabolut"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-badge"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="#000"
                    >
                      <path
                        d="M12 2c5.523 0 10 4.477 10 10s-4.477 10-10 10S2 17.523 2 12 6.477 2 12 2zm0 2c-4.418 0-8 3.582-8 8s3.582 8 8 8 8-3.582 8-8-3.582-8-8-8zm0 2c3.313 0 6 2.687 6 6s-2.687 6-6 6-6-2.687-6-6 2.687-6 6-6zm0 2c-2.209 0-4 1.791-4 4s1.791 4 4 4 4-1.791 4-4-1.791-4-4-4z"
                      />
                    </svg>
                  </a>

                  <a
                    href="https://www.linkedin.com/company/stabolut/"
                    target="_blank"
                    rel="noopener noreferrer"
                    className="store-badge"
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      viewBox="0 0 24 24"
                      width="20"
                      height="20"
                      fill="#000"
                    >
                      <path
                        d="M19 0H5a5 5 0 0 0-5 5v14a5 5 0 0 0 5 5h14a5 5 0 0 0 5-5V5a5 5 0 0 0-5-5zM8 19H5V8h3v11zM6.5 6.732c-.966 0-1.75-.79-1.75-1.764s.784-1.764 1.75-1.764 1.75.79 1.75 1.764-.783 1.764-1.75 1.764zM20 19h-3v-5.604c0-3.368-4-3.113-4 0V19h-3V8h3v1.765c1.396-2.586 7-2.777 7 2.476V19z"
                      />
                    </svg>
                  </a>
                </div>
              </Offcanvas.Body>
            </Offcanvas>
          </div>
        </div>

        {/* Hero Section */}
        <div
          style={{
            position: "relative",
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            textAlign: "center",
            color: "#fff"
          }}
        >
          <div data-aos="fade-up" style={{ position: "relative", zIndex: 2, overflow: "hidden" }}>
           
            <p className="text-white  heading-font header-head">The Stablecoin Standard</p>
            <p className="mb-5 text-white header-text">
              Decentralized, Transparent, Yield-bearing
            </p>
            {/* <button className="bg-btn">
              Get this app
              <svg
                width="9"
                height="13"
                viewBox="0 0 9 13"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                style={{ marginLeft: "5px" }}
              >
                <path
                  d="M1.36871 3.40802L4.48594 6.52525L1.36871 9.64248"
                  stroke="white"
                  strokeWidth="1.24689"
                />
              </svg>
            </button> */}
          </div>
        </div>
      </div>
    </div>
  );
};
